//! @ngInject
export function billingIssuesTemplateSetupModalCtrl($scope, $rootScope, $uibModalInstance, fields, data, DatabaseApi, toaster, FormService, $filter) {

    const parseData = (data) => {
        if (Array.isArray(data.roles) && Array.isArray(data.roleIds) && data.roles.length === data.roleIds.length) {
            data.roleIds = data.roleIds.map((roleId, idx) => ({ id: roleId.toString(), label: data.roles[idx] }));
        } else {
            data.roleIds = [];
        }
        delete data.roles;
        if (Array.isArray(data.issues) && data.issues.length > 0) {
            data.issues = data.issues.map(issue => ({ id: issue, label: $filter("titlecasefromsnake")(issue) }));
        } else {
            data.issues = [];
        }

        data.contractTypeIds = Array.isArray(data.contractTypeIds)
            ? data.contractTypeIds.map(id => ({ id }))
            : [];
        data.serviceCodeIds = Array.isArray(data.serviceCodeIds)
            ? data.serviceCodeIds.map(id => ({ id }))
            : [];
        data.officeIds = Array.isArray(data.officeIds)
            ? data.officeIds.map(id => ({ id }))
            : [];
        data.teamIds = Array.isArray(data.teamIds)
            ? data.teamIds.map(id => ({ id: id.toString() }))
            : [];
        data.coordinatorIds = Array.isArray(data.coordinatorIds)
            ? data.coordinatorIds.map(id => ({ id: id.toString() }))
            : [];
        data.certifications = Array.isArray(data.certifications)
            ? data.certifications.map(c => ({ id: c }))
            : [];

        if (data.billable === true) {
            data.billable = [{ id: "true" }];
        } else if (data.billable === false) {
            data.billable = [{ id: "false" }];
        } else {
            data.billable = [];
        }

        return data;
    };

    $scope.data = parseData(angular.copy(data));
    $scope.fields = FormService.getFields(fields, $scope.data);
    $scope.form = {};

    $scope.submitForm = () => {
        if ($scope.form.data.$invalid) {
            return;
        }

        const body = FormService.prepareFormData($scope.fields);
        body.issues = body.issues.map(issue => issue.id);
        body.roleIds = body.roleIds.map(role => parseInt(role.id));

        body.contractTypeIds = Array.isArray(body.contractTypeIds)
            ? body.contractTypeIds.map(x => typeof x.id === "number" ? x.id : parseInt(x.id))
            : [];
        body.serviceCodeIds = Array.isArray(body.serviceCodeIds)
            ? body.serviceCodeIds.map(x => typeof x.id === "number" ? x.id : parseInt(x.id))
            : [];
        body.officeIds = Array.isArray(body.officeIds)
            ? body.officeIds.map(x => typeof x.id === "number" ? x.id : parseInt(x.id))
            : [];
        body.teamIds = Array.isArray(body.teamIds)
            ? body.teamIds.map(x => parseInt(x.id))
            : [];
        body.coordinatorIds = Array.isArray(body.coordinatorIds)
            ? body.coordinatorIds.map(x => parseInt(x.id))
            : [];
        body.certifications = Array.isArray(body.certifications)
            ? body.certifications.map(x => x.id)
            : [];

        const billableArr = Array.isArray(body.billable) ? body.billable : [];
        const hasBillable = billableArr.some(x => x.id === "true");
        const hasNotBillable = billableArr.some(x => x.id === "false");
        if (hasBillable && !hasNotBillable) {
            body.billable = true;
        } else if (!hasBillable && hasNotBillable) {
            body.billable = false;
        } else {
            body.billable = null;
        }

        if (typeof body.includeBilledVisits !== "boolean") {
            body.includeBilledVisits = null;
        }
        if (typeof body.excludeNoClockTimes !== "boolean") {
            body.excludeNoClockTimes = null;
        }
        if (typeof body.excludeUnpaidVisits !== "boolean") {
            body.excludeUnpaidVisits = null;
        }
        if (typeof body.excludeMissedVisits !== "boolean") {
            body.excludeMissedVisits = null;
        }

        if (body.issues.length === 0) {
            toaster.pop("error", "Missing issues");
            return;
        }
        if (body.roleIds === 0) {
            toaster.pop("error", "Missing roles");
            return;
        }

        if ($scope.data.id) {
            const editUrl = "agencies/:agencyId/agency_members/:agencyMemberId/billing_issues_templates_settings/:billingIssuesTemplateId"
                .replace(":agencyId", $rootScope.agencyId)
                .replace(":agencyMemberId", $rootScope.agencyMemberId)
                .replace(":billingIssuesTemplateId", $scope.data.id);
            DatabaseApi.put(editUrl , body)
                .then((res) => {
                    toaster.pop('success', "Billing issues template saved");
                    $scope.closeModal();
                }, (err) => {
                    toaster.pop('error', "Something went wrong", "Could not change billing issues template settings")
                });
        } else {
            const createUrl = "agencies/:agencyId/agency_members/:agencyMemberId/billing_issues_templates_settings"
                .replace(":agencyId", $rootScope.agencyId)
                .replace(":agencyMemberId", $rootScope.agencyMemberId);
            DatabaseApi.post(createUrl, body).then((res) => {
                toaster.pop('success', "Billing issues template saved");
                $scope.closeModal();
            }, (err) => {
                toaster.pop('error', "Something went wrong", "Could not create billing issues template");
            });
        }
    };

    $scope.closeModal = () => {
        $uibModalInstance.close('ok');
    };

    $scope.exit = () => {
        $uibModalInstance.dismiss();
    };
};
